import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getMerchants } from './merchant-api';

import type { Merchant } from '../model/merchant';

export function useMerchantsListQuery(
  queryOptions: Omit<UseQueryOptions<Merchant[]>, 'queryKey' | 'queryFn'> = {}
) {
  return useQuery({
    queryKey: ['merchants-list'],
    queryFn: getMerchants,
    ...queryOptions,
  });
}
